var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"mx-auto mxw-300 p-1 text-center message"},[_c('div',[_vm._v(_vm._s(_vm.readableTime))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.message.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }